import styled from 'styled-components';

const HEADER_HEIGHT = 40;

export const Container = styled.div`
  position: fixed;
  bottom: 4.5rem;
  right: 1.25rem;
  background: ${props => props.theme.colors.pink};
  border: 3px solid hsla(0, 0%, 100%, 0.16);
  padding: 10px 16px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  z-index: 9999999;
  transition: all 0.2s ease-in-out;
  animation: pulseAnimationCss 2s infinite;

  &:hover {
    background: ${props => props.theme.colors.danger};
  }

  @keyframes pulseAnimationCss {
    0% {
      -moz-box-shadow: 0 0 0 0 ${props => props.theme.colors.primary}50;
      box-shadow: 0 0 0 0 ${props => props.theme.colors.primary}50;
    }
    70% {
      -moz-box-shadow: 0 0 0 6px ${props => props.theme.colors.primary}10;
      box-shadow: 0 0 0 6px ${props => props.theme.colors.primary}10;
    }
    100% {
      -moz-box-shadow: 0 0 0 0 ${props => props.theme.colors.primary}10;
      box-shadow: 0 0 0 0 ${props => props.theme.colors.primary}10;
    }
  }

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
  }
`;

export const Wrapper = styled.section`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

export const InnerContainer = styled.div`
  position: relative;
  z-index: 9999999;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;	
  //overflow-y: scroll;
  border-radius: 6px;
  padding: 1rem 1.5rem;

  ::-webkit-scrollbar {
    border-radius: 8px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 9999px;
    background-color: #bed0de50;
  }

  > header {
    display: flex;
    justify-content: flex-end;
    height: ${HEADER_HEIGHT}px;

    > button {
      color: #ffffff;
      
      > svg {
        color: #ffffff;
      }
    }
  }

  > main {
    position: absolute;
    height: calc(100% - ${HEADER_HEIGHT}px);
    width: 100%;
    overflow-y: scroll;
  }
`;

export const CloseBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  top: -10px;
  right: -10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  color: #ffffff;

  &:hover {
    color: #ffffff;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  opacity: 1;
  backdrop-filter: blur(7px) saturate(110%) !important;
  transition: all 0.2s ease-in-out 0s !important;
  background: rgba(0, 0, 0, 0.4) !important;
`;

export const BackClick = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
`;